export default __webpack_public_path__ + "static/media/on-demand-shuttle.37635b0a.png";